import { fetchToken } from '@agissc/ktag-map';
import { useQuery } from '@tanstack/react-query';
import config from '../../../../utils/AppConfig';

export interface CodeValue {
  codeValue: string;
  meaning: string;
}

const fetchCodeValues = async (
  attributeName: string,
  layercaption: string,
  servicename: string,
  isPublic: boolean,
) => {
  const headers = new Headers();
  if (process.env.NODE_ENV !== 'development') {
    if (!isPublic) {
      const token = await fetchToken();
      headers.set('Authorization', `Bearer ${token}`);
    }
  }

  const response = await fetch(
    `${config.apis.codeValues}?attributeName=${attributeName}&layercaption=${layercaption}&servicename=${servicename}`,
    {
      method: 'GET',
      headers,
    },
  );

  const codeValues = (await response.json()) as CodeValue[];
  return codeValues;
};

export const useCodeValues = (
  attributeName: string,
  layercaption: string,
  servicename: string,
  isPublic: boolean,
) => {
  return useQuery<CodeValue[]>({
    queryKey: ['codeValueResults', attributeName, layercaption, servicename],
    queryFn: () => fetchCodeValues(attributeName, layercaption, servicename, isPublic),
    gcTime: 3600000,
    staleTime: Infinity,
  });
};
